
import { mapGetters } from 'vuex'
import vuedraggable from 'vuedraggable'
import { ossUploadFile } from '@/utils/uploader'

export default {
    components: { vuedraggable },
    props: {
        tip: {
            type: String,
            default: '仅支持jpg.png格式，分辨率为16：9'
        },
        value: {
            // 初始化图片
            type: [String, Array]
        },
        defaultUrl: {
            type: Array,
            default () {
                return []
            }
        },
        size: {
            type: Number,
            default: 500
        },
        uploadPath: {
            type: String,
            default: '/operate/'
        },
        limit: {
            type: Number
        },
        goodsType: {
            type: String
        },
        upLoadType: {
            type: String
        }
    },
    data () {
        return {
            parentVal: this.value, // 同步父节点传递进来的 默认数据
            showLoading: false,
            dialogVisible: false,
            fileList: [], // 页面显示的数组
            // 防止重复提交
            loading: false,
            dialogImageUrl: null,
            percentage: 0,
            imageName: null
        }
    },
    computed: {
        ...mapGetters({
            // ossToken: 'ossToken'
        })
    },
    watch: {
        value (newValue, oldVal) {
            //
            if (newValue !== oldVal) {
                //
                this.parentVal = this.value
                this.transFormValueToFileList()
            }
        },
        parentVal (v) {
            if (this.limit === 1) {
                if (!v) { return }
                const val = v || v[0]
                this.$emit('input', val.toString())
                return
            }
            this.$emit('input', v)
        }
    },
    created () {
        this.transFormValueToFileList()
    },
    methods: {
        onEnd (_end) {
            this.syncFileListToParentVal()
        },
        onMove (evt) {
            // 阻止拖拽到 no-drag 元素的位置
            return !evt.related.classList.contains('no-drag')
        },
        transFormValueToFileList () {
            let tempStr
            if (this.value) {
                const _tempArray = []
                // 判断传递进来的数据是否为数组
                if (Array.isArray(this.value)) {
                    // 如果是数组,就循环数据
                    this.value.forEach(item => {
                        if (item) {
                            // 将每一个传递进来的 url 地址用 '/' 分割
                            const tempStr = item.split('/')
                            // 将传递进来的每个 url 重构成 key 为 name,url 的对象添加到新的数组中
                            // debugger;
                            _tempArray.push({
                                // name 取 url 最后一个 '/' 后面的字符
                                name: tempStr[tempStr.length - 1],
                                url: item
                            })
                        }
                    })
                    this.fileList = _tempArray
                } else {
                    tempStr = this.value.split('/')
                    this.fileList = [{ name: tempStr[tempStr.length - 1], url: this.value }]
                }
                // debugger
            } else {
                this.fileList = []
            }
        },
        handlePictureCardPreview (val) {
            this.imageName = val.name
            this.dialogImageUrl = val.url
            this.dialogVisible = true
        },
        // 删除 图片上传的图片
        delUploadImg (index) {
            this.fileList.splice(index, 1)
            this.syncFileListToParentVal()
        },
        // 同步  fileList 到  parentVal 返回给父组件里面
        syncFileListToParentVal () {
            const tempParentVal = []
            this.fileList.forEach(item => {
                tempParentVal.push(item.url)
            })
            this.parentVal = tempParentVal
        },
        // 选择文件
        chooseFile () {
            this.$refs.uploader.value = ''
            this.$refs.uploader.click()
        },
        // 处理文件选择
        async handleFileChange (e) {
            const files = [...e.target.files]
            if (!files.length) { return }

            // 检查文件数量限制
            const remainingSlots = this.limit - this.fileList.length
            if (files.length > remainingSlots) {
                this.$message.warning(`最多还能上传${remainingSlots}张图片`)
                return
            }

            // 检查每个文件
            const validFiles = []
            for (const file of files) {
                if (this.beforeAvatarUpload(file)) {
                    validFiles.push(file)
                }
            }

            if (!validFiles.length) { return }

            // 开始批量上传
            this.showLoading = true
            try {
                let fileDataList = await ossUploadFile(this.upLoadType, validFiles, {
                    ContentType: this.video ? 'video/mp4' : 'image/jpeg',
                    progress: (percentage, _cpt) => {
                        this.percentage = percentage
                    }
                })

                // 确保返回数组格式
                if (!Array.isArray(fileDataList)) {
                    fileDataList = [fileDataList]
                }

                // 过滤掉null值
                const successFiles = fileDataList.filter(item => item)

                if (successFiles.length) {
                    if (this.limit === 1) {
                        this.fileList = successFiles
                        this.parentVal = successFiles[0].url
                    } else {
                        this.fileList.push(...successFiles)
                        this.syncFileListToParentVal()
                    }
                } else {
                    this.$message.error('上传失败，请重试')
                }
            } catch (error) {
                console.error('上传失败:', error)
                this.$message.error('上传失败，请重试')
            } finally {
                this.showLoading = false
            }
        },
        beforeAvatarUpload (file) {
            const isJPG = file.type === 'image/png' || file.type === 'image/jpeg'
            const isLt = file.size / 1024 / 1024 > this.size
            if (!isJPG) {
                this.$message.error(`${file.name} 不是 JPG/PNG 格式!`)
                return false
            }
            if (isLt) {
                this.$message.error(`${file.name} 大小不能超过${this.size}KB!`)
                return false
            }
            if (this.width || this.height) {
                return new Promise((_resolve, reject) => {
                    const _URL = window.URL || window.webkitURL
                    const img = new Image()
                    img.src = _URL.createObjectURL(file)
                    img.onload = () => {
                        if (this.width) {
                            if (img.width > this.width) {
                                this.$message.warning({
                                    message: `${file.name} 宽度最大为${this.width}`
                                })
                                reject(new Error(`${file.name} 宽度最大为${this.width}`))
                            }
                        }
                        if (this.height) {
                            if (img.height > this.height) {
                                this.$message.warning({
                                    message: `${file.name} 高度最大为${this.height}`
                                })
                                reject(new Error(`${file.name} 高度最大为${this.height}`))
                            }
                        }
                    }
                })
            } else {
                return true
            }
        }
    }
}
